module.exports = __webpack_public_path__ + "static/media/Portrait-10029.9b7b106e.jpg";